import React, { useState } from 'react';
import notice from 'src/common/components/Notice';
import BaseModal from 'src/common/components/Modal';
import UtilInputs from 'src/common/components/UtilInputs';
import { parameterAPI } from 'src/api/modules/parameters';
import { defaultBody, newBodyForm } from '../utils/list_data';

const AddParam = ({ open, onClose, onSuccess }) => {
	const [dataForm, setDataForm] = useState(defaultBody);

	const handleChange = ({ target }) =>
		setDataForm({ ...dataForm, [target.name]: target.value });

	const onSaveData = () => {
		parameterAPI
			.createParameter(dataForm)
			.then(() => {
				onSuccess('Parámetro creado', 'success', 1);
				setDataForm(defaultBody);
			})
			.catch(() => {
				notice('Ocurrió un error al crear nuevo parámetro');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Agregar nuevo parámetro"
			confirmLabel="Guardar"
			onConfirm={onSaveData}
			onClose={() => {
				onClose();
				setDataForm(defaultBody);
			}}
			onCancel={() => {
				onClose();
				setDataForm(defaultBody);
			}}
		>
			<UtilInputs
				formValues={dataForm}
				inputValues={newBodyForm}
				onValuesChange={handleChange}
			/>
		</BaseModal>
	);
};

export default AddParam;
